import React from 'react';
import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  max-width: 160px;
  width: 100%;
`;

export const Button = styled.a`
  display: flex;
  border-radius: 24px;
  border: 2px solid transparent;
  overflow: hidden;

  &:focus-visible {
    border-color: var(--color-focus);
  }
`;

type ButtonContentProps = {
  hoverTriggerClass?: string;
};

export const ButtonContent = styled.span<ButtonContentProps>`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0 28px;
  height: 40px;
  line-height: 1;
  font-weight: 400;
  white-space: nowrap;
  color: var(--color-text);

  > span {
    position: relative;
    z-index: 10;
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    background: linear-gradient(
      110deg,
      var(--color-scale-20) 10%,
      var(--color-gradient-start) 75%,
      var(--color-gradient-end) 100%
    );
    transform: scaleX(500%) translateX(-75%);
    transform-origin: 0 50%;
    transition: transform 400ms ease-out;
  }

  ${({ hoverTriggerClass }) => (hoverTriggerClass ? `${hoverTriggerClass}:hover &::before,` : `&:hover::before,`)}
  ${Button}:focus-visible &::before {
    transform: scaleX(500%) translateX(0);
  }
`;

export type GradientButtonProps = {
  href: string;
  target?: string;
  dataLink?: string;
} & ButtonContentProps;

const GradientButton: React.FC<GradientButtonProps> = ({ href, target, dataLink, hoverTriggerClass, children }) => {
  return (
    <ButtonContainer>
      <Button href={href} target={target} data-link-id={dataLink}>
        <ButtonContent hoverTriggerClass={hoverTriggerClass}>
          <span>{children}</span>
        </ButtonContent>
      </Button>
    </ButtonContainer>
  );
};

export default GradientButton;
